// 场景切换后的目标文案与对话配置（数据驱动）
// dialog: 切换后播放的对话 key（DIALOGS 中的 key）
// dialogCond: 对话播放条件（需某 flag 为 true）
// flag: 切换后设置的 flag
// objective: 切换后的目标文案
export const SCENE_TRANSITIONS = {
  riverside: { objective: '在江堤找到守砚', dialog: 'street_to_riverside' },
  street_01: { objective: '捡汉字 → 按 F 补诗净化招牌与失语者' },
  freeze_center: { objective: '返回冷冻中心' },
  subway: {
    objective: '探索地铁站，小心梗鬼',
    dialog: 'subway_depth_return',
    dialogCond: 'subway_depth_log_read',
    dialogOnceFlag: 'subway_depth_returned',
    flag: 'subway_depth_returned',
  },
  alley_district: {
    objective: '在废墟居民区找到守砚',
    dialog: 'riverside_to_alley',
    dialogCond: 'met_shuyuan',
  },
  house_a: { objective: '查看屋内旧物，然后离开' },
  house_b: { objective: '清除民居B里的梗鬼' },
  stadium: { objective: '在茧房收集「眠」「处」「风」「少」', dialog: 'alley_to_stadium' },
  ruined_library: {
    objective: '在废图书馆找到方知远的终端',
    dialog: 'chapter5_intro',
    dialogOnceFlag: 'chapter5_started',
    flag: 'chapter5_started',
  },
  data_center: { objective: '走向石桥尽头的蓝色光影' },
  network_nexus: { objective: '在网络中枢找到守卷人' },
  memory_abyss: { objective: '在记忆深渊找到幼年Sydney' },
  lost_village: { objective: '唤醒失语者聚居地中的失语者' },
  subway_depth: {
    objective: '在检修通道深处寻找站长日志',
    dialog: 'subway_depth_enter',
    dialogOnceFlag: 'subway_depth_entered',
    flag: 'subway_depth_entered',
  },
};
